module.exports = __webpack_public_path__ + "img/01.9f4d7f45.png";